import React from 'react';
import {
  Card as ShadcnCard,
  CardHeader as ShadcnCardHeader,
  CardFooter as ShadcnCardFooter,
  CardTitle as ShadcnCardTitle,
  CardAction as ShadcnCardAction,
  CardDescription as ShadcnCardDescription,
  CardContent as ShadcnCardContent,
} from '@/components/ui/shadcn/card';
import { cn } from '@/lib/utils';

// Wrapper components that extend shadcn with our customizations

interface CardProps extends React.ComponentProps<typeof ShadcnCard> {
  /** Enable the ghost glow effect (disabled by default) */
  glow?: boolean;
}

function Card({ className, glow = false, ref, ...props }: CardProps) {
  return (
    <ShadcnCard
      ref={ref}
      className={cn(glow && 'ghost-glow', className)}
      {...props}
    />
  );
}

const CardHeader = ShadcnCardHeader;
const CardFooter = ShadcnCardFooter;
const CardTitle = ShadcnCardTitle;
const CardAction = ShadcnCardAction;
const CardDescription = ShadcnCardDescription;
const CardContent = ShadcnCardContent;

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
